/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Settings_ForbiddenInputs */

const vi_notification_settings_forbidden = /** @type {(inputs: Notification_Settings_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không có quyền xem cài đặt thông báo`)
};

/**

* @param {Notification_Settings_ForbiddenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notification_settings_forbidden = /** @type {((inputs?: Notification_Settings_ForbiddenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Settings_ForbiddenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notification_settings_forbidden(inputs)
});